import api from "../axios_service.js";

export async function getContrato(id) {
  const response = await api.get(`/contratos/${id}`);
  return response.data.result;
}
